// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-error-boundary{display:flex;flex-direction:column;width:100%;height:100vh;color:#fff;justify-content:center;align-items:center;text-align:center;background-color:#5645f5;padding:1rem}.page-error-boundary .btn.reload-btn{background-color:#fff}.page-error-boundary i{font-size:96px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
